module.exports = __webpack_public_path__ + "static/media/file.cbf8ef10.svg";